<template>
  <b-container class="mb-6">
    <b-row>
      <b-col md="12"
             lg="6"
             class="text-center"
      >
        <div class="download-item mt-4">
          <img src="/img/management/grade-move/pdf.svg"
               alt=""
               class="ml-n3"
               loading="lazy"
          />
          <p class="description mb-0">{{ $t('management.generate_users.success.pdf.description') }}</p>
          <div>
            <SLink
              appearance="b-button"
              variant="primary-light"
              class="mt-4"
              size="md"
              download
              :href="bulk.meta.pdf"
              @click="$emit('downloadFile')"
            >
              {{ $t('management.generate_users.success.pdf.download_btn') }}
            </SLink>
          </div>
        </div>
      </b-col>
      <b-col md="12"
             lg="6"
             class="text-center"
      >
        <div class="download-item mt-4">
          <img src="/img/management/grade-move/csv.svg"
               alt=""
               class="ml-n3"
               loading="lazy"
          />
          <p class="description mb-0">{{ $t('management.generate_users.success.csv.description') }}</p>
          <div>
            <SLink
              appearance="b-button"
              variant="primary-light"
              class="mt-4"
              size="md"
              download
              data-cy="download-excel"
              :href="bulk.meta.xls"
              @click="$emit('downloadFile')"
            >
              {{ $t('management.generate_users.success.csv.download_btn') }}
            </SLink>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'GenerateUsersSuccess',
  props: {
    bulk: {
      type: Object,
      default: () => {},
    },
  },

  computed: {},

  emits: ['downloadFile'],

  methods: {},
  created() {},
}
</script>

<style scoped lang="scss">
img {
  max-height: 216px;
  filter: var(--primary-svg-filter);
}
</style>
